import { useTheme } from "@mui/material";

const severityColors = ["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"] as const;
export type SeverityColor = (typeof severityColors)[number];

export const isSeverityColor = (color: string): color is SeverityColor => {
    return (severityColors as unknown as string[]).includes(color);
};

type UseSeverityColorResult = {
    getColor: (severity?: SeverityColor) => string;
};

export const useSeverityColor = (): UseSeverityColorResult => {
    const theme = useTheme();

    return {
        getColor: (severity?: SeverityColor) => {
            switch (severity) {
                case "error":
                    return theme.palette.error.main;
                case "warning":
                    return theme.palette.warning.main;
                case "success":
                    return theme.palette.success.main;
                case "info":
                    return theme.palette.info.main;
                case "primary":
                    return theme.palette.text.primary;
                case "secondary":
                    return theme.palette.text.secondary;
                case "disabled":
                    return theme.palette.text.disabled;
                case "action":
                    return theme.palette.action.active;
                default:
                    return theme.palette.text.primary;
            }
        },
    };
};
